import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Store, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Branches() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");

  const load = () => api.get("/branches").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name) return toast.error("Enter branch name");
    try {
      await api.post("/branches", { name, address, phone });
      toast.success("Branch added");
      setName(""); setAddress(""); setPhone("");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed");
    }
  };

  const remove = async (b) => {
    if (!window.confirm(`Delete ${b.name}?`)) return;
    await api.delete(`/branches/${b.id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="space-y-5 max-w-3xl" data-testid="branches-page">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 flex items-center gap-2">
          <Store className="w-6 h-6 text-emerald-700" /> Branches
        </h1>
        <p className="text-sm text-slate-500">Add new branches — switch branch from the sidebar; bills get tagged to the selected branch.</p>
      </div>

      <Card className="p-5 border-slate-200">
        <h3 className="font-display font-bold mb-3 flex items-center gap-2"><Plus className="w-4 h-4 text-emerald-700" /> New Branch</h3>
        <form onSubmit={add} className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div><Label className="text-xs">Branch Name *</Label><Input data-testid="branch-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1 h-10" placeholder="Branch 2 — City Clinic" /></div>
          <div><Label className="text-xs">Address</Label><Input value={address} onChange={(e) => setAddress(e.target.value)} className="mt-1 h-10" /></div>
          <div><Label className="text-xs">Phone</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-1 h-10" /></div>
          <div className="sm:col-span-3">
            <Button type="submit" data-testid="add-branch-btn" className="bg-emerald-900 hover:bg-emerald-800">Add Branch</Button>
          </div>
        </form>
      </Card>

      <Card className="border-slate-200">
        <Table data-testid="branches-table">
          <TableHeader><TableRow><TableHead>Branch</TableHead><TableHead>Address</TableHead><TableHead>Phone</TableHead><TableHead className="text-right">Action</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((b) => (
              <TableRow key={b.id} data-testid={`branch-row-${b.id}`}>
                <TableCell className="font-semibold">{b.name}</TableCell>
                <TableCell className="text-sm text-slate-500">{b.address || "—"}</TableCell>
                <TableCell className="font-mono-num text-sm">{b.phone || "—"}</TableCell>
                <TableCell className="text-right">
                  <Button size="icon" variant="ghost" onClick={() => remove(b)} data-testid={`delete-branch-${b.id}`}><Trash2 className="w-4 h-4 text-red-600" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
